export default "__VITE_ASSET__BomtaQGz__"